import { Tooltip } from '@base-ui/react/tooltip'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface TooltipPopupProps extends PartProps<Tooltip.Popup.Props> {
  className?: string
}

/**
 * Dark in both themes, like Toast: `dark` pins the semantic tokens to the dark ramp. A hint that
 * changes colour with the page reads as part of the page; pinned, it reads as chrome.
 */
function TooltipPopup({ className, ...props }: TooltipPopupProps) {
  return (
    <Tooltip.Popup
      className={twMerge(
        'bg-background-overlay text-foreground dark shadow-lg',
        'corner-squircle text-pretty rounded-xl px-2 py-1 text-left text-sm',
        'w-max max-w-[240px]',
        // With a hotkey the chips sit beside the label, a step closer to the edge than the text.
        'has-[[data-slot=kbd]]:flex has-[[data-slot=kbd]]:items-center has-[[data-slot=kbd]]:gap-2 has-[[data-slot=kbd]]:pr-1',
        // Fades only. A hint that grows pulls the eye, and the 300ms delay already stops a row of
        // triggers from flashing. The curve is an arbitrary property because Tailwind drops an arbitrary ease class as ambiguous with the animation plugin.
        'transition-opacity duration-150 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
        'data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
        className,
      )}
      {...props}
    />
  )
}

export { TooltipPopup }
